import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import DiagnosisCodeModal from './DiagnosisCode_Modal';
import { deleteDiagnosisCode, getDiagnosisCodeList } from '../actions/DiagnosisCodeActions';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../../components/SortingCustom';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../actions/utilAction';
import Tooltip from '../../../../../components/Tooltip';
import PaginatorCustom from '../../../../../components/paginationCustom';

class DiagnosisCodeList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      // diagnosisCodes: [],
      includedData: [],
      diagnosisCodeId: null,
      // meta_data: null,
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleSearchDiagnosisCode = this.handleSearchDiagnosisCode.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getDiagnosisCodeList(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }
  componentWillMount() {
    // this.props.getMasterData();
    this.loadData();
    // if (this.props.diagnosisCodes) {
    //   this.setState({
    //     diagnosisCodes: this.props.diagnosisCodes.data,
    //     includedData: this.props.diagnosisCodes.included,
    //     meta_data: this.props.diagnosisCodes.meta,
    //   });
    // }
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.postDiagnosisCodes && this.props.postDiagnosisCodes !== nextProps.postDiagnosisCodes) {
      this.loadData();
    }
    if (nextProps.deleteDiagnosisCodes && this.props.deleteDiagnosisCodes !== nextProps.deleteDiagnosisCodes) {
      this.loadData();
    }
  }


  handleReset = () => {
    Alert.closeAll();
    this.setState({ diagnosisCodeId: null });
    this.refs.DiagnosisCode.setState({ value: '' });
    this.loadData();
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, diagnosisCodeId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, diagnosisCodeId) => {
    this.props.deleteDiagnosisCode(diagnosisCodeId);
    Alert.closeAll();
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Once you click yes, all the clients linked with this diagnosis code will get effected. Are you sure you want to delete this diagnosis code?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, diagnosisCodeId: obj.id });
  }

  handleSearchDiagnosisCode(event) {
    if (event.DiagnosisCode !== undefined) {
    }
  }
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('DiagnosisCodeListForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }
  renderData() {
    if (!this.props.diagnosisCodes || !this.props.diagnosisCodes.length) {
      return (
        <tr>
          <td colSpan="3">
            <div className="familydl text-center no-record">No record found</div>
          </td>
        </tr>
      );
    }
    return this.props.diagnosisCodes.map((Obj, index) => {
      return (
        <tr key={index}>
          <td>{Obj.code}</td>
          <td>
            {Obj.description && Obj.description.length > 0 ?
              <Tooltip description={Obj.description} />
              : null}
            {Obj.description != null && Obj.description.length > 75 ? SubString(Obj.description, 75) : Obj.description != null ? Obj.description : 'N/A'}
          </td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }
  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Manage Diagnosis Code</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  <RaisedButton label="Add Diagnosis Code" primary={true} onTouchTap={this.handleOpen} />
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchDiagnosisCode)}>
                        <Field
                          name="DiagnosisCode"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      {this.props.addPermission ?
                        <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>
                        : null
                      }
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <DiagnosisCodeModal diagnosisCodeId={this.state.diagnosisCodeId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="25%"><SortingCustom setSortColumn={this.setSortColumn} columnName='Code' displayName='Diagnosis Code' /></th>
                        <th width="65%"><SortingCustom setSortColumn={this.setSortColumn} columnName='Description' displayName='Description' /></th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="10%">Actions</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData()}
                    </tbody>
                  </table>
                  {this.props.metaData && this.props.metaData.totalPages ?
                    <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DiagnosisCodeList = reduxForm({
  form: 'DiagnosisCodeListForm',
})(DiagnosisCodeList);

function mapStateToProps(state) {
  // console.log('state......',state.diagnosisCode);
  // Start For Role Permission
  let userActionPermission = [], diagnosisCodes = [], metaData = null;
  if (state.diagnosisCode.diagnosisCodesList && state.diagnosisCode.diagnosisCodesList.data) {
    diagnosisCodes = state.diagnosisCode.diagnosisCodesList.data;
    metaData = state.diagnosisCode.diagnosisCodesList.meta;
    // console.log('state', state.diagnosisCode.diagnosisCodesList.data);
  }
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_DIAGNOSISCODES_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DIAGNOSISCODES_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DIAGNOSISCODES_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DIAGNOSISCODES_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    diagnosisCodes: diagnosisCodes,
    postDiagnosisCodes: state.diagnosisCode.postDiagnosisCodeData,
    deleteDiagnosisCodes: state.diagnosisCode.deleteDiagnosisCode,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    metaData: metaData,
  };
}
export default connect(mapStateToProps, { getDiagnosisCodeList, deleteDiagnosisCode })(DiagnosisCodeList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/components/index.js